//#region IMPORT
import React, { useState, useRef } from 'react';
import SUB_BASIC_02 from './SUB_BASIC_02';
import { useNavigate } from 'react-router-dom';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { useSearch1, useSearch2 } from './SUB_BASIC_02_QUERY';
import dayjs from 'dayjs';
//#endregion

function SUB_BASIC_02F(props) {
  //#region 변수
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);
  const dispatch = useDispatch();

  // 그리드 데이터
  const [rowData1, setRowData1] = useState([]);
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);

  const gridRef1 = useRef();
  //#endregion

  //#region 쿼리
  // 적격수급인 평가서 목록 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      setRowData1(rows);
    },
  });

  const ResetLogic1 = () => {
    setRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  };

  // 그리드 조회
  const SearchLogic1 = async () => {
    ResetLogic1();
    await Search1();
  };

  const { run: Search2 } = useSearch2({
    onSuccess: async (rows) => {
      const data = rows || [];

      if (!data || data.length === 0) {
        dispatch(
          showSnackbar({
            message: '인쇄할 데이터가 없습니다.',
            type: 'error',
          })
        );
        return;
      }

      if (data[0]?.type === 'Error') {
        dispatch(
          showSnackbar({
            message: data[0]?.message || '인쇄할 데이터가 없습니다.',
            type: 'error',
          })
        );
        return;
      }

      const row = data[0];
      const deductionRow = data.find((r) => String(r.isDeduction ?? 'N') === 'Y');
      const deductionScore =
        Number(deductionRow?.deductions ?? deductionRow?.resultScore) || 0;
      const custNm =
        searchInfo?.custList?.find((item) => item.value === searchInfo?.custCd)
          ?.name || '';

      if (!selectedRowData1[0]) {
        dispatch(
          showSnackbar({
            message: '인쇄할 항목을 선택하세요.',
            type: 'warning',
          })
        );
        return;
      }

      let headerData = {
        gradeYear: selectedRowData1[0].sbmYear || '',
        name: userInfo.userNm || '',
        updateDate: selectedRowData1[0].updateDate
          ? dayjs(selectedRowData1[0].updateDate).format('YYYY-MM-DD')
          : '',
        custNm: custNm || '',
        evaName: selectedRowData1[0].name || '',
        evaluatorOpinion: row.evaluatorOpinion || '',
        gradeFirstHalf: selectedRowData1[0].sbmHalf || '',
        deductions: deductionScore,
        deductionItemName: String(deductionRow?.itemName ?? '감점사항'),
        deductionStandard: String(deductionRow?.evalStandard ?? ''),
        deductionScore,
        totalScore: row.totalScore || 0,
        grade: row.grade || 0,
      };

      const tableData = data
        .filter((r) => String(r?.isDeduction ?? 'N') !== 'Y')
        .slice()
        .sort((a, b) => (Number(a?.sortOrdr) || 0) - (Number(b?.sortOrdr) || 0))
        .slice(0, 10)
        .map((r, idx) => ({
          no: idx + 1,
          itemName: String(r?.itemName ?? ''),
          evalStandard: String(r?.evalStandard ?? ''),
          maxScore: Number(r?.maxScore) || 0,
          resultScore: Number(r?.resultScore) || 0,
          isDeduction: 'N',
          deductions: 0,
          totalScore: Number(row?.totalScore) || 0,
        }));

      // 인쇄 실행
      try {
        const printData = {
          FileName: 'SUB_BASIC_01',
          HeaderData: JSON.stringify(headerData),
          TableData: JSON.stringify(tableData),
        };

        const response = await Commons.Axios(
          'report',
          Global.base.useUrl + Global.urls.Reports.reports,
          printData
        );
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank');
      } catch (e) {
        console.log(e);
        dispatch(showSnackbar({ message: e.message, type: 'error' }));
      }
    },
  });
  //#endregion

  //#region 나머지 함수
  // 인쇄 함수
  const PrintLogic1 = () => {
    if (!selectedRowData1[0]) {
      dispatch(
        showSnackbar({
          message: '인쇄할 항목을 선택하세요.',
          type: 'warning',
        })
      );
      return;
    }

    Search2({ sbmId: selectedRowData1[0].sbmId });
  };
  //#endregion

  return (
    <SUB_BASIC_02
      navigate={navigate}
      userInfo={userInfo}
      gridRef1={gridRef1}
      rowData1={rowData1}
      setRowData1={setRowData1}
      selectedRowData1={selectedRowData1}
      setSelectedRowData1={setSelectedRowData1}
      changedRowData1={changedRowData1}
      setChangedRowData1={setChangedRowData1}
      filterClick2={props.filterClick2}
      setFilterClick2={props.setFilterClick2}
      searchClick2={props.searchClick2}
      setSearchClick2={props.setSearchClick2}
      addClick2={props.addClick2}
      setAddClick2={props.setAddClick2}
      saveClick2={props.saveClick2}
      setSaveClick2={props.setSaveClick2}
      deleteClick2={props.deleteClick2}
      setDeleteClick2={props.setDeleteClick2}
      printClick2={props.printClick2}
      setPrintClick2={props.setPrintClick2}
      listClick2={props.listClick2}
      setListClick2={props.setListClick2}
      // 함수
      validateSelection={props.validateSelection}
      ResetLogic1={ResetLogic1}
      SearchLogic1={SearchLogic1}
      PrintLogic1={PrintLogic1}
    />
  );
}

export default SUB_BASIC_02F;
